import React from 'react'
import ApproverExpenseReports from 'src/app/ApproverExpenseReports/ApproverExpenseReports'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { expensesAllReportsRouteProps } from 'src/navigation/routeProps'

const ExpensesAllReportsAppRoute: AppRoute = {
  routeProps: expensesAllReportsRouteProps,
  component: <ApproverExpenseReports />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ExpensesAllReportsAppRoute
